module.exports = __webpack_public_path__ + "img/print-receipt.e382851e.svg";